import formatDate from '@/helpers/formatDate';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/new/components/shadcn/dialog';
import { Chronology } from '@/types';

interface AddToChronologyDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  isLoadingChronologies: boolean;
  chronologies: Chronology[];
  handleSelectChronology: (chronologyId: string) => void;
  isAddingFacts: boolean;
}

export const AddToChronologyDialog = ({
  isOpen,
  onOpenChange,
  isLoadingChronologies,
  chronologies,
  handleSelectChronology,
  isAddingFacts,
}: AddToChronologyDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--filter" />
            Add to Existing Chronology
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col items-center justify-start">
          {isLoadingChronologies || isAddingFacts ? (
            <div className="flex h-full items-center justify-center">
              <Icon className="lucide--loader-circle h-8 w-8 animate-spin duration-700" />
            </div>
          ) : (
            <div className="w-full">
              <p className="mb-4 pb-1 text-sm text-gray-700">Select an existing chronology to add facts to.</p>
              <div className="flex w-full flex-col justify-between gap-2">
                {chronologies.map((chronology) => {
                  return (
                    <div
                      key={chronology.id}
                      className="flex items-center justify-between rounded-md border bg-gradient-to-r from-gray-50 px-4 py-2 text-sm"
                    >
                      <div className="flex flex-col">
                        <p className="line-clamp-1 font-medium text-ellipsis">{chronology.title}</p>
                        <p className="text-xs text-gray-500">Created {formatDate(chronology.createdDate)}</p>
                      </div>
                      <Button
                        className="bg-gray-100"
                        onClick={() => handleSelectChronology(chronology.id)}
                        disabled={isAddingFacts}
                      >
                        <Icon className="iconify lucide--plus-circle h-4 w-4" /> Add
                      </Button>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
